<div class="doc-footer border mb-5" style="border-radius: 10px; padding: 0.5rem">
  <p>
    <b *ngIf="ehTitular">Assinatura do beneficiário titular:</b>
    <b *ngIf="!ehTitular">Assinatura do beneficiário:</b>
  </p>
  <p>
    Assinatura via área logada pelo beneficiário
    {{ nomeTitular }} em {{ dataAssinatura }} às {{ horaAssinatura }},
    <ng-container *ngIf="ehDocFinal">
      comercialização através da corretora {{ nomeCorretora }} e vendedor {{ nomeVendedor }},
    </ng-container>
    conforme Art. 7º da RN 413
  </p>
  <p>
    Data de preenchimento da proposta:
    {{ dataAssinatura }}
  </p>
</div>
